import { render, staticRenderFns } from "./staffTeachSec.vue?vue&type=template&id=7f9b209c&scoped=true&"
import script from "./staffTeachSec.vue?vue&type=script&lang=js&"
export * from "./staffTeachSec.vue?vue&type=script&lang=js&"
import style0 from "./staffTeachSec.vue?vue&type=style&index=0&id=7f9b209c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9b209c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
